const ENVIRONMENT_ENUM = [
    'https://localhost',
    'https://dev-b2c.voegol.cloud',
    'https://hom-venda-b2c.voegol.com.br',
    'https://hom-tsts-venda-b2c.voegol.com.br',
    'https://hom-b2c.voegol.com.br',
    'https://hom-vcliente-b2c.voegol.com.br',
    'https://hom-minhasviagens-b2c.voegol.com.br',
    'https://sus-b2c.voegol.com.br',
    'https://hom-checkin-b2c.voegol.com.br',
    'https://hom-financeiro-b2c.voegol.com.br',
    'https://hom-posvenda-b2c.voegol.com.br',
    'https://hom-regressivo-b2c.voegol.com.br',
    'https://b2c.voegol.com.br',
];

const getDestRefSource = (): string | null => {
    const currentUrl = new URLSearchParams(window.location.search);

    const url = currentUrl.get('redirect_uri')?.toLowerCase();

    if (!url) {
        return null;
    }

    const destParam = new URL(url).searchParams.get('dest');

    if (!destParam) {
        return null;
    }

    const decoded = decodeURIComponent(destParam);

    if (!decoded.includes('ref=')) {
        return null;
    }

    const refUrl = decoded.split('ref=')[1];

    const cbk = new URL(refUrl).searchParams.get('cbk');

    if (!cbk) {
        return null;
    }

    return cbk;
}

const getRedirectURICallback = (): string | null => {
    const currentUrl = new URLSearchParams(window.location.search);
  
    const url = currentUrl.get('redirect_uri')?.toLowerCase();
  
    if (!url) {
      return null;
    }
  
    const destParam = new URL(url).searchParams.get('dest');
  
    if (!destParam) {
      return null;
    }
  
    const decoded = decodeURIComponent(destParam);
  
    const params = new URLSearchParams(decoded);
  
    const cbk = params.get('cbk');
  
    if (!cbk) {
      return null;
    }
  
    return cbk;
  }

const getCallbackEnvironment = (): string => {
    const params = new URLSearchParams(window.location.search);

    const cbkParam = params.get('cbk') || getRedirectURICallback() || getDestRefSource();

    if (!cbkParam) {
        const origin = window.location.origin.toLocaleLowerCase();

        const isHmlEnv = origin.includes('hml');
        const isDevEnv = origin.includes('dev');

        if (isHmlEnv || isDevEnv) {
            return ENVIRONMENT_ENUM[5];
        }

        return ENVIRONMENT_ENUM[12];
    }

    const cbk = Number(cbkParam);

    return ENVIRONMENT_ENUM[cbk];
}

export const redirectGolEnviroment = (): string => {
    getDestRefSource();

    const envUrl = getCallbackEnvironment();

    return envUrl;
}

export const setRedirectEnvironmentInLocalStorage = ({ sourceAccess, authClient }: { sourceAccess?: string, authClient: string }): void => {
    const redirectLogic = {
        GOL: redirectGolEnviroment
    }
    const hasRedirectLogic = redirectLogic?.[sourceAccess?.toUpperCase() as keyof typeof redirectLogic];
    console.log('hasRedirectLogic', hasRedirectLogic);
    if (sourceAccess && hasRedirectLogic) {
        localStorage.setItem('@auth0_src', sourceAccess);
        localStorage.setItem('@auth0_client', authClient);
        localStorage.setItem('@auth0_origin_redirect', hasRedirectLogic());
        return;
    }

    localStorage.removeItem('@auth0_src');
    localStorage.removeItem('@auth0_client');
    localStorage.removeItem('@auth0_origin_redirect');
}

